/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserCreateUsername } from './userCreateUsername';
import type { UserCreateRole } from './userCreateRole';
import type { UserLifecycleState } from './userLifecycleState';
import type { UserCreateActive } from './userCreateActive';
import type { UserCreateTitle } from './userCreateTitle';
import type { UserCreateTrial } from './userCreateTrial';
import type { UserCreateCohort } from './userCreateCohort';
import type { UserCreateContext } from './userCreateContext';
import type { UserCreateAvatar } from './userCreateAvatar';
import type { UserCreateProfilePhotoBlobPath } from './userCreateProfilePhotoBlobPath';
import type { UserCreateFeatures } from './userCreateFeatures';
import type { UserCreateExternalStudentId } from './userCreateExternalStudentId';
import type { UserCreatePassword } from './userCreatePassword';
import type { UserCreateCourse } from './userCreateCourse';

/**
 * Model how to create a user, include password
 */
export interface UserCreate {
  username?: UserCreateUsername;
  firstname: string;
  lastname: string;
  email: string;
  role?: UserCreateRole;
  /** Lifecycle state for all users. Note that 'stale' and 'finished' primarily apply to students. */
  state?: UserLifecycleState;
  active?: UserCreateActive;
  title?: UserCreateTitle;
  trial?: UserCreateTrial;
  cohort?: UserCreateCohort;
  context?: UserCreateContext;
  avatar?: UserCreateAvatar;
  profilePhotoBlobPath?: UserCreateProfilePhotoBlobPath;
  features?: UserCreateFeatures;
  externalStudentId?: UserCreateExternalStudentId;
  password?: UserCreatePassword;
  course?: UserCreateCourse;
  /** Whether to send a welcome email to the user. */
  sendWelcomeEmail?: boolean;
  /** Whether to include the password in the welcome email. */
  includePassword?: boolean;
}
